import script from "./Certification_Items.vue?vue&type=script&setup=true&lang=ts"
export * from "./Certification_Items.vue?vue&type=script&setup=true&lang=ts"

import "./Certification_Items.vue?vue&type=style&index=0&id=2f6c4f50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f6c4f50"]])

export default __exports__